import create from 'zustand';

interface HeaderStore {
  isModalGnbOpen: boolean;
  isModalBookmarksOpen: boolean;
  isModalCompanyListOpen: boolean;
  isModalSearchOpen: boolean;
  setIsModalGnbOpen: (isModalGnbOpen: boolean) => void;
  setIsModalBookmarksOpen: (isModalBookmarksOpen: boolean) => void;
  setIsModalCompanyListOpen: (isModalCompanyListOpen: boolean) => void;
  setIsModalSearchOpen: (isModalSearchOpen: boolean) => void;
}

const initialState = {
  isModalGnbOpen: false,
  isModalBookmarksOpen: false,
  isModalCompanyListOpen: false,
  isModalSearchOpen: false,
};

const useHeaderStore = create<HeaderStore>((set) => ({
  ...initialState,
  setIsModalGnbOpen: (isModalGnbOpen: boolean) => set(() => ({ isModalGnbOpen })),
  setIsModalBookmarksOpen: (isModalBookmarksOpen: boolean) => set(() => ({ isModalBookmarksOpen })),
  setIsModalCompanyListOpen: (isModalCompanyListOpen: boolean) =>
    set(() => ({ isModalCompanyListOpen })),
  setIsModalSearchOpen: (isModalSearchOpen: boolean) => set(() => ({ isModalSearchOpen })),
}));

export default useHeaderStore;
